import * as React from 'react'

import { DepositsFlow, DepositsStep } from 'even-ts-static'

import { OfferList } from './OfferList/container'
import { SavingsCalculator } from './SavingsCalculator/container'
import { SingleOffer } from './SingleOffer/container'

interface OwnProps {
  depositsFlow?: DepositsFlow
  selectedStep: DepositsStep
}

type Props = OwnProps

export const DepositsView: React.FC<Props> = (props) => {
  if (props.depositsFlow === DepositsFlow.SavingsCalculator) {
    return <SavingsCalculator />
  }

  switch (props.selectedStep) {
    case DepositsStep.SingleOffer:
      return <SingleOffer />
    case DepositsStep.OfferList:
    default:
      return <OfferList />
  }
}
